module.exports = __webpack_public_path__ + "static/media/SPIRIT.52e06396.png";